<template>
	<div class="wrap">
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test" :to="{ path: '/jianjie' }">集团简介设置</el-breadcrumb-item>
			<el-breadcrumb-item>添加子公司</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			<el-form label-width="110px" :model="formData">
				<el-form-item label="权重">
					<el-input v-model="formData.weights" type="number"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<!-- :label-position="labelPosition" :model="formLabelAlign" -->
				<el-form-item label="子公司图片">
					<!-- <el-input v-model="formData.picUrl"></el-input> -->
					<!-- v-model="formLabelAlign.name" -->
					<!-- <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :limit="3">
						<el-button size="small" type="primary">点击上传</el-button><el-tag type="danger" style="margin-left: 20px;">注意：子公司的图片需是3张</el-tag>
					</el-upload> -->

					<el-upload class="upload-demo" :before-upload="beforeUpload" :action="uploadUrl" :on-remove="onRemove" :on-success="onSuccess"
					 :limit="3" :file-list="fileList" list-type="picture">
						<el-button size="small" type="primary">点击上传图片</el-button>
						<el-tag type="danger" style="margin-left: 20px;">需要更换图片时请删除原来的图片后再点击上传图片！！！</el-tag>
					</el-upload><!-- :on-preview="handlePreview" :on-remove="handleRemove" -->
					<!-- <img :src="current" /> -->
				</el-form-item>
				<el-form-item label="子公司标题">
					<el-input v-model="formData.title"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="子公司简介">
					<el-input v-model="formData.jianjie"></el-input><!-- v-model="formLabelAlign.type" -->
				</el-form-item>
			</el-form>

			<el-button type="success" class="submitBtn" @click="submit">立即提交</el-button>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: '',
				formData: {
					title: '',
					jianjie: '',
					weights:''
				},
				fileList: [],
				fileList2: [],
				current: '',
				imgHead: '',
				uploadUrl: this.$httpTitle + '/uploadImgQiniugroup?pathName=activityNewInfo'
				/* fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}], */

			}
		},
		created() {
			this.imgHead = this.$imgTitle;
			console.log('获取到的id===' + this.$route.query.id)
			this.id = this.$route.query.id;
			this.getDetailData();
			var data = {
				"data": {
					"code": 0,
					"message": "success.",
					"data": {
						"id": 1,
						"createTime": 1590654542000,
						"updateTime": 1590654542000,
						"name": "广九九航贸易有限公司",
						"introduction": "简介：九航贸易，现代化网购综合服务商，九航公司是一家管理完善、设备先进、资金雄厚、健康咨询服务类现代化网购综合服务商，涵盖了美容养生，瘦身塑形等服务领域。",
						"weights": 5,
						"subsidiaryPicture": "%E5%B9%BF%E4%B8%9C%E4%B9%9D%E8%88%AA1.png,%E5%B9%BF%E4%B8%9C%E4%B9%9D%E8%88%AA2.png,%E5%B9%BF%E4%B8%9C%E4%B9%9D%E8%88%AA3.png"
					}
				},
				"status": 200,
				"statusText": "",
				"headers": {
					"date": "Mon, 29 Jun 2020 03:25:53 GMT",
					"transfer-encoding": "chunked",
					"content-type": "application/json;charset=UTF-8"
				},
				"config": {
					"url": "/v1/official/manag/subsidiary/detail",
					"method": "get",
					"params": {
						"id": "1"
					},
					"headers": {
						"Accept": "application/json, text/plain, */*"
					},
					"baseURL": "http://xhm.jiuhuakang.com",
					"transformRequest": [null],
					"transformResponse": [null],
					"timeout": 0,
					"xsrfCookieName": "XSRF-TOKEN",
					"xsrfHeaderName": "X-XSRF-TOKEN",
					"maxContentLength": -1
				},
				"request": {}
			}
		},
		methods: {
			async getDetailData() {
				var res = await this.$http.get('/v1/official/manag/subsidiary/detail', {
					params: {
						id: this.id
					}
				})
				if (res.data.code == 0) {
					this.formData.title = res.data.data.name
					this.formData.jianjie = res.data.data.introduction
					this.formData.weights = res.data.data.weights
					res.data.data.subsidiaryPicture.split(',').forEach((item, index) => {
						var obj = {}
						obj['name'] = '原来封面图' + (index + 1)
						obj['url'] = this.imgHead + item
						this.fileList.push(obj)
						this.fileList2.push(obj)
					})


				}
				console.log(JSON.stringify(res))
			},
			beforeUpload(file) {
				console.log('触发了=' + JSON.stringify(file))
			},
			onSuccess(res) {
				console.log("res=" + JSON.stringify(res))

				var obj = {};
				obj['url'] = res
				this.fileList2.push(obj)
				console.log('选择成功后的fileList=' + JSON.stringify(this.fileList))
				console.log('选择成功后的fileList2=' + JSON.stringify(this.fileList2))

			},
			onRemove(file, fileList) {
				var newfileList = fileList;
				var newfileList2 = this.cloneObj(fileList);
				/* console.log("onremove1=" + JSON.stringify(file))
				console.log("onremove2=" + JSON.stringify(fileList)) */
				this.fileList = newfileList;
				this.fileList2 = newfileList2;
				var onremove2 = [{
					"name": "原来封面图1",
					"url": "http://group.jiuhangjituan.cn/%E5%B9%BF%E4%B8%9C%E4%B9%9D%E8%88%AA1.png",
					"uid": 1593407802026,
					"status": "success"
				}, {
					"name": "原来封面图2",
					"url": "http://group.jiuhangjituan.cn/%E5%B9%BF%E4%B8%9C%E4%B9%9D%E8%88%AA2.png",
					"uid": 1593407802027,
					"status": "success"
				}]
			},
			async submit() {
				var obj = {}
				obj['id'] = this.id;
				obj['name'] = this.formData.title;
				obj['introduction'] = this.formData.jianjie;
				obj['weights'] = +this.formData.weights; //权重
				this.imgHead = '';
				var picUrlArr = [];
				this.fileList2.forEach((item) => {
					console.log(item.url)
					
					var url = item.url.replace(/http:\/\/group.jiuhangjituan.cn\//gi,'')
					picUrlArr.push(url)
				})
				var picUrlStr = picUrlArr.join(',')
				console.log('picUrlStr=' +typeof picUrlStr)
				console.log('picUrlStr=' + picUrlStr)
				obj['subsidiaryPicture'] = picUrlStr //封面图
				console.log(JSON.stringify(obj))
				console.log(sessionStorage.getItem('jiuhangtoken'))
				var res = await this.$http.post('/v1/official/manag/subsidiary/update',{
					request:obj
				} )
				if(res.data.code == 0){
					 this.$message.success('修改成功');
				}else{
					this.$message.error(res.data.message)
				}
				console.log("结果="+JSON.stringify(res))
			},
			cloneObj(obj) {
				return JSON.parse(JSON.stringify(obj));
			}
		}
	}
</script>

<style lang="less" scoped>
	.submitBtn {
		margin-left: 110px;
	}
</style>
